import { ENV_INFO } from "~/observability/setup";

// eslint-disable-next-line @typescript-eslint/no-restricted-imports
export { captureMessage, withScope } from "@sentry/browser";
export { ENV_INFO, captureException } from "~/observability/setup";

console.log(
  `%cTwelve client init: release ${ENV_INFO?.release || "unknown"} in ${ENV_INFO?.name || "unknown"}`,
  "color:#5149DD",
);
